import {CourseMembershipAttrs} from '@freckle/educator-entities/ts/roster/models/course-membership'
import {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'

// Get all the students for the given courseId
export const getStudentIdsforCourse = (
  courseId: number,
  courseMemberships: Array<CourseMembershipAttrs>
): Array<number> => courseMemberships.filter(cm => cm.courseId === courseId).map(cm => cm.studentId)

export function getStudentsforCourse(
  students: Array<StudentAttrs>,
  courseId: number,
  courseMemberships: Array<CourseMembershipAttrs>
): Array<StudentAttrs> {
  const studIdsInCourse = new Set(getStudentIdsforCourse(courseId, courseMemberships))
  return students.filter(({id}) => studIdsInCourse.has(id))
}
